(function () {
  'use strict';

  /* mr-subscription-presentation.js -- Sprint 7 Refinement, Phase 1,
     Stage D (2026-07-14). Extended 2026-07-14 (Movements IV-VII pass) --
     relocation into #mr-continuation-shell. Extended 2026-07-15
     (Purchase Method Selector redesign). Extended again 2026-07-15
     (form-association fix + selling-plan sync fix). Extended again
     2026-07-21 (card-click activation fix + subscription price sync --
     see bottom of this header).

     WHAT THIS IS FOR: the "Purchase options" block (One-time purchase /
     A Gift Every Week / Monthly Waqf Subscription, etc.) is rendered
     entirely by the Seal Subscriptions app embed -- confirmed live via
     DOM inspection, it is NOT theme markup. Nothing in this theme's
     source (any section, snippet, or template JSON) references it --
     it is injected at runtime as a child of the real <product-form>,
     the same general pattern as Selleasy's widget (see
     mr-selleasy-reposition.js's own header for that precedent). This
     script follows that same file's proven approach: watch for the
     widget to mount, then restructure its presentation -- never its
     option data, prices, discount labels, selected/checked state, or
     its own separate "Subscription details" info panel
     (.sls-more-info-container), which is left completely untouched.

     CONFIRMED LIVE STRUCTURE (2026-07-15, Wheelchair, re-verified):
       .sealsubs-container
         > div (unnamed wrapper)
             > label.sls-purchase-options-label ("Purchase options")
             > .sls-purchase-options-container
                 > input (Seal's own hidden state input -- left
                   untouched, not moved, stays a direct child of the
                   container)
                 > .sls-option-container.seal-table   (one per plan, one
                   sibling per option -- each contains exactly one
                   input[type=radio][name^="subs_type"], all sharing the
                   SAME name attribute -- confirmed one real radio
                   group, not a two-level structure)
                     > .seal-row
                         > .seal-col.seal-col-radio > .sls-selling-plan-group-first-line
                             > input.sls-option[type=radio] + span.sls-custom-radio
                         > .sls-label-container.seal-col > .sls-selling-plan-group-first-line
                             > label.sls-selling-plan-group-name (the
                               option's visible name text) +
                               .sls-total-price.sls-price-container
                               (recurring price, currently empty on this
                               store's config) [+ .sls-savings-badge
                               nearby on secondary options, currently
                               empty too]
         > .sls-more-info-container ("Subscription details" panel --
           always untouched by this script, at every stage)

     Selector for the one-time row: the .sls-option-container that
     contains input[value="one_time"]. Every other .sls-option-container
     sibling is a secondary (subscription) option. This does not assume
     a fixed count -- works whether a product has 1 extra plan (Weekly
     only, e.g. Gift Qur'an) or 2 (Weekly + Monthly, e.g. Wheelchair).

     2026-07-15 PURCHASE METHOD SELECTOR REDESIGN -- Akkas's explicit
     brief: the previous "one-time row + collapsed '+' disclosure for
     weekly/monthly" pattern (Stage D, then the Host Voice copy pass)
     read too much like a CTA button and hid the subscription choice
     behind an extra click. New brief: present all purchase methods as
     three equal-width selection cards, always visible together (no
     disclosure/hiding), so the section reads as "I'm choosing how to
     purchase," not "this is the final action." Presentation only --
     the actual <input type="radio"> elements (their name/value/checked
     state), Seal's own hidden state input, and every pricing/discount
     value are the exact same real DOM nodes, just re-parented into a
     new grid wrapper and given an additional class for styling. No new
     click-handling JS added -- whatever native label/radio click
     behaviour Seal's own markup already has is preserved unchanged, not
     re-implemented. [2026-07-21: this last sentence no longer fully
     holds -- see CARD-CLICK ACTIVATION FIX below for why a minimal
     click relay became necessary on the newer Gift-product widget
     layout, and exactly how little it does.]

     buildDisclosure()/the <details> wrapper are removed as of this pass
     -- replaced by buildCardsWrap(), which produces a plain, always-
     visible <div class="mr-c-purchase-cards"> instead. restructure()'s
     job is now: find the one-time option, find every secondary option,
     move all of them (one-time first, in original order) into the new
     grid, and add the "mr-c-purchase-card" class to each so
     mr-t-product-stage-l.css can style them as equal cards. It does NOT
     touch which radio is checked, Seal's pricing, or Seal's discount
     badge content.

     COPY: Akkas gave exact card wording for the Wheelchair page --
     "One-time purchase / Weekly Waqf / Monthly Waqf" -- but this script
     is shared across every conviction-zone product (Wheelchair, Chair,
     Qur'an, Water, Meal Boxes), and Seal's own real plan names differ
     per product (Waqf products say "A Waqf Every Week"; Gift products
     say "A Gift Every Week"). Rather than hardcoding "Waqf" (wrong on
     Gift products) or leaving Seal's own longer phrasing untouched
     (doesn't match what Akkas asked for), extractActWord() parses the
     act-word Seal itself already rendered ("Waqf", "Gift", etc.) out of
     its own live label text via two fixed patterns ("A {word} Every
     Week" / "Monthly {word} Subscription") and reassembles it as
     "Weekly {word}" / "Monthly {word}" -- reusing Seal's own real word,
     not inventing one. This produces exactly Akkas's requested
     "Weekly Waqf" / "Monthly Waqf" on the Wheelchair page (verified
     against its real live label text) while staying correct on other
     products. The same extracted word is reused for the new heading
     ("Choose how you'd like to place this {word}.", Akkas's exact
     sentence with the word substituted). If a product's real label text
     doesn't match either pattern (unexpected Seal copy), that row's
     text -- and the heading -- are left exactly as Seal rendered them
     rather than guessing; the new card grid layout still applies
     regardless, since the layout change needs no text parsing to be
     safe. [2026-07-21 note: the newer rollout plan groups are named
     "Subscribe Monthly" / "Subscribe Weekly" -- neither pattern
     matches, so on those products the labels and heading correctly
     stay exactly as Seal rendered them. Expected, not a bug.]

     WHAT THIS STILL DOES NOT DO: it does not remove, hide, disable, or
     unselect any plan. It does not change Seal's own default-selected
     plan. It does not touch pricing, discount percentages, billing
     intervals, or the "Subscription details" panel. It does not fire
     if the widget never mounts (products with no subscription option --
     fails silently). If a product only ever has ONE purchase option
     (one-time only, no subscription plans configured at all), this
     script does nothing -- there is nothing to lay out as a grid, and
     (per relocate(), unchanged below) nothing gets relocated either.

     RELOCATION (2026-07-14 pass) -- once restructure() has succeeded,
     the ENTIRE .sls-purchase-options-container -- not just the new
     cards grid -- is moved into the empty anchor div
     #mr-continuation-shell, rendered directly inside the scale_picker
     case in sections/mr-s-product-commitment.liquid, so it always sits
     right after Scale regardless of block_order. This moves the real
     node -- Seal's own listeners, its hidden state input, the checked
     radio, everything -- exactly like Selleasy's relocation; nothing
     about the widget's own internals is touched. restructure()'s
     "already processed" early-return still returns `true` (not `false`)
     so a later init pass still confirms/relocates an already-built grid
     instead of silently doing nothing.

     2026-07-15 FORM-ASSOCIATION FIX (Akkas-approved, this pass) --
     #mr-continuation-shell sits OUTSIDE the real <form> element (it is
     rendered as a sibling in the block loop, not inside the buy_buttons
     block's own <form> markup). Confirmed live: once relocate() moves
     .sls-purchase-options-container into that shell, its radio inputs
     and Seal's own hidden selling_plan input stop being included in
     FormData(form) entirely -- the browser only auto-associates form
     controls that are DOM descendants of a <form>, or that carry an
     explicit form="<id>" attribute pointing to one. Net effect before
     this fix: selecting Weekly or Monthly Waqf never reached the real
     Add to Cart submission -- every order silently went through as
     one-time, regardless of which card was selected. This was a
     pre-existing gap from the 2026-07-14 relocation pass itself (the
     old stacked/disclosure design had the exact same bug), not
     something introduced by the card redesign -- see
     MR-Purchase-Method-Selector-Redesign-Report.md for the full
     root-cause writeup.

     Fix: tagFormAssociation(), called from inside restructure() BEFORE
     relocate() ever runs (i.e. while the container is still in its
     original, genuinely-inside-the-form position), walks up from the
     container to find its real, current <form> ancestor via
     container.closest('form'), reads that form's own id attribute, and
     sets form="<that id>" on every input inside the container --
     Seal's radio buttons and its own hidden state input alike. The
     HTML form= attribute associates a control with a form by id
     regardless of where in the document the control physically lives,
     so this restores correct submission behaviour without moving
     anything back and without touching Seal's own markup, values, or
     listeners. Same technique already used successfully elsewhere on
     this page for the same class of problem (see
     snippets/mr-c-wheelchair-names.liquid and
     snippets/mr-c-fulfilment-personalise.liquid, both of which render
     outside the form and use form="{{ product_form_id }}" directly in
     Liquid) -- this is the JS-side equivalent, needed here only because
     Seal's inputs are injected at runtime and can't be tagged from
     Liquid. If no form ancestor can be found (unexpected page
     structure), tagging is skipped rather than guessed -- the grid
     still builds and relocates as before, just without the fix, so
     nothing regresses further than it already was.

     Also this pass: the "Purchase options" label Seal renders as a
     sibling of the container (see structure diagram above) is left
     behind, empty and unlabelled, in the widget's old position once
     relocate() moves the container away -- removeStrandedHeading(),
     called at the end of relocate(), removes that specific label
     element only. Seal's own separate "Subscription details" panel
     (.sls-more-info-container, one level up, a sibling of the unnamed
     wrapper that held the label) is a completely different element and
     is never touched.

     2026-07-15 SELLING-PLAN SYNC FIX (Akkas-approved, same pass as the
     form-association fix above) -- the form-association fix alone was
     NOT sufficient. Confirmed by A/B testing this exact page against
     Shopify's live/MAIN theme (which has none of this relocation code,
     Seal's widget in its original, never-moved position): on live,
     clicking a secondary option immediately writes the real selling
     plan id into container's own hidden input[name="selling_plan"] --
     Seal has a working 'change'-time mechanism for this. On the
     relocated build theme, that same hidden input never updates, even
     with correct form association, so it always submits empty and every
     order silently goes through as one-time regardless of the selected
     card. Root cause: Seal's own update mechanism almost certainly
     relies on event delegation scoped to its original wrapper (e.g.
     .sealsubs-container), which the radio is no longer inside once
     relocated -- a 'change' event on the moved radio can't bubble into
     an ancestor it's no longer a descendant of. Moving the whole widget
     back to fix this was ruled out (Akkas: keep the new layout exactly
     as-is); re-implementing Seal's own selection logic was also ruled
     out (Akkas: do not modify Seal's logic).

     What actually fixes it, with no guessing involved: each secondary
     .sls-option-container already contains its own
     select[name="subs_interval"] -- a single-option, Seal-rendered,
     Seal-populated field whose one option's value IS that exact plan's
     real selling plan id (confirmed by direct comparison against the
     live theme's own successful submission -- both Weekly's and
     Monthly's ids matched exactly). This value is Seal's own real,
     correct, pre-computed data; nothing here invents or recomputes it.
     wireSellingPlanSync() reads it and copies it into the container's
     own selling_plan hidden input on 'change' -- i.e. it relays a value
     Seal itself already produced into the field Shopify's cart API
     actually reads, restoring the exact hand-off that Seal's own
     delegation used to do before relocation broke it. It also runs once
     immediately after wiring, so the correct value is set even if no
     option is ever touched (matches Seal's own live behaviour: empty
     for one-time, since one-time's option has no subs_interval field).
     Zero Seal markup, values, prices, or its own listeners are touched
     -- this only ever writes to the one hidden field the relocation
     itself broke the hand-off to.

     2026-07-21 DUPLICATE selling_plan INPUT FIX (this pass) -- the
     2026-07-15 sync fix wrote the selected plan id into the ONE hidden
     selling_plan input inside .sls-purchase-options-container. Found
     live on the Gift Dates page (and by construction on every product
     sharing this layout): Seal renders a SECOND hidden
     input[name="selling_plan"] as a direct child of its
     .sealsubs-target-element -- OUTSIDE the options container, so
     relocate() leaves it behind inside the real <form>. That leftover
     input is natively form-associated (a real DOM descendant, no form=
     attribute needed), always empty (Seal's broken-by-relocation
     delegation never writes it either), and sits BELOW the relocation
     shell in document order -- so at submit time the request carries
     selling_plan twice, correct value first, empty value last, and
     Shopify's cart keeps the LAST one. Confirmed by intercepting a real
     /cart/add POST: the checked Monthly radio and the container's
     correctly-synced input were both present, yet the request's final
     selling_plan was "" and the cart line landed one-time at full
     price. This -- not a failure of the 07-15 sync itself -- is why
     subscriptions on the live theme submit as one-time purchases.

     Fix: applySync() in wireSellingPlanSync() now writes the selected
     value into EVERY selling_plan input associated with the real form
     -- the container's own AND any Seal keeps inside the form --
     found via document-wide query filtered to this form's id (nested
     descendants and form=-tagged alike). Same principle as before:
     only relaying Seal's own already-correct plan id into the
     field(s) Shopify actually reads; when one-time is selected every
     copy is set to empty, which is exactly Seal's own behaviour. A
     persistent, lightweight MutationObserver on the form re-runs
     applySync whenever Seal injects fresh nodes later (it re-renders
     with new random radio-group names after cart events), so a
     late-arriving empty input can never silently override the
     customer's selection again. The observer only ever re-writes
     values that differ, so it settles immediately and cannot loop.

     2026-07-21 CARD-CLICK ACTIVATION FIX (this pass) -- found on the
     now-live theme via the Gift Dates page (first of the newer
     "Subscribe Monthly" / "Subscribe Weekly" rollout products to be
     QA'd): clicking a card's BODY does not select it at all. Confirmed
     live by a real coordinate click on the "Subscribe Monthly" card:
     the one_time radio stayed checked, selling_plan stayed empty.
     Root cause is the same relocation-broken delegation family as the
     2026-07-15 fixes, one layer earlier in the chain: on this widget
     layout Seal's visible label (label.sls-selling-plan-group-name)
     has NO for= attribute and does NOT wrap the radio, so a click on
     the card body has no native radio association whatsoever -- on
     Seal's original, never-relocated markup its own delegated click
     handler (scoped to an ancestor the container no longer sits
     inside) did that job. Net effect: a real customer clicking
     "Subscribe Monthly" got nothing -- no checked state, no synced
     plan, and a full-price one-time cart.

     Fix: wireCardClicks(), called from restructure() alongside the
     other two fixes. One click listener per .sls-option-container: if
     the click didn't land on the radio itself and the radio isn't
     already checked, check it and dispatch a bubbling 'change' event --
     exactly what the browser itself would have done had the label been
     associated. That change event is the same one wireSellingPlanSync()
     and wirePriceSync() already listen for, so the whole existing chain
     (selling_plan hand-off, price update) runs identically whether the
     radio was reached natively or via this relay. On widget layouts
     where clicking a card already works natively (the radio's own
     click), the radio is already checked by the time the click bubbles
     to the container, so the relay is a no-op -- safe on every product
     sharing this script, additive only on the broken ones.

     2026-07-21 SUBSCRIPTION PRICE SYNC (same pass) -- selecting a
     subscription must show the subscriber price (10% off on Gift
     products per the rollout pricing; 0% on Waqf products, where this
     is numerically a no-op). Seal's original widget did this on its
     own; post-relocation it doesn't, and this store's Seal config
     renders its in-widget price/badge elements empty anyway. The
     numbers are NOT computed here: wirePriceSync() fetches Shopify's
     own /products/<handle>.js once (same origin, localization-aware)
     and reads each variant's selling_plan_allocations -- the exact
     per-variant, per-plan prices Shopify itself will charge, the same
     source of truth the cart uses. Verified live on Gift Dates: base
     1873, allocation 1686 for both plans = exactly 10% off, and every
     variant carries allocations for every plan.

     What it updates: ONLY the text of the main price display
     (#price-<sectionId>, resolved from the real form's own id -- the
     same "derive from the form, don't hardcode" rule as
     tagFormAssociation), specifically the .price__regular and
     .price__sale price-item elements. The currency symbol/suffix
     format is preserved by templating the element's own current text
     (replace the numeric part, keep everything around it) rather than
     rebuilding a money string from scratch. Card markup, badges, and
     Seal's own elements are not touched -- Akkas's brief: the UI stays
     exactly as it is, only the price number follows the selection.

     Variant changes: Dawn's <product-info> re-fetches and swaps the
     price block's markup on every variant change (the exact morph
     behaviour already documented in mr-tier-picker-prices.js's own
     header), which silently reverts the displayed price to the
     one-time figure. Same proven remedy as that file: a
     MutationObserver on the price wrapper re-applies after every
     morph. Re-entrancy is prevented by never writing when the element
     already shows the target text -- our own write triggers exactly
     one more observer pass, which then finds nothing to change and
     stops. If the checked option is one-time, the target IS the
     variant's own base price, so re-applying is always safe and
     self-correcting, never fighting Dawn's own render. If the product
     .js fetch fails, or any expected element is missing, price sync
     silently does nothing -- the display simply stays server-rendered,
     exactly as before this pass. */

  var CONTAINER_SELECTOR = '.sls-purchase-options-container';
  var OPTION_SELECTOR = '.sls-option-container';
  var LABEL_SELECTOR = '.sls-selling-plan-group-name';
  var PAGE_HEADING_SELECTOR = '.sls-purchase-options-label';
  var SELLING_PLAN_INPUT_SELECTOR = 'input[name="selling_plan"]';
  var INTERVAL_SELECTOR = '[name="subs_interval"]';
  var ONE_TIME_VALUE = 'one_time';
  var WRAP_CLASS = 'mr-c-purchase-cards-wrap';
  var GRID_CLASS = 'mr-c-purchase-cards';
  var CARD_CLASS = 'mr-c-purchase-card';
  var HEADING_CLASS = 'mr-c-purchase-cards__heading';
  var SHELL_SELECTOR = '#mr-continuation-shell';
  var GIVE_UP_MS = 15000; // matches mr-selleasy-reposition.js's own window for the same class of problem

  function alreadyProcessed(container) {
    return !!container.querySelector('.' + WRAP_CLASS);
  }

  // Parses Seal's own real, live label text to recover the act-word
  // ("Waqf", "Gift", ...) it already contains, so relabelled copy stays
  // correct per-product instead of hardcoding one word for every product
  // sharing this script. Returns null (do nothing) on any unexpected shape.
  function extractActWord(labelText) {
    var text = (labelText || '').trim();
    var weekly = /^A\s+(.+?)\s+Every\s+Week$/i.exec(text);
    if (weekly) return { freq: 'weekly', actWord: weekly[1].trim() };
    var monthly = /^Monthly\s+(.+?)\s+Subscription$/i.exec(text);
    if (monthly) return { freq: 'monthly', actWord: monthly[1].trim() };
    return null;
  }

  function buildCardsWrap(actWord) {
    var wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;

    if (actWord) {
      var heading = document.createElement('p');
      heading.className = HEADING_CLASS;
      heading.textContent = "Choose how you'd like to place this " + actWord + '.';
      wrap.appendChild(heading);
    }

    var grid = document.createElement('div');
    grid.className = GRID_CLASS;
    wrap.appendChild(grid);

    return { wrap: wrap, grid: grid };
  }

  // Restores correct Add to Cart submission for the purchase options this
  // container holds. Must run while `container` is still in its original,
  // real-<form>-descendant position -- see the FORM-ASSOCIATION FIX note
  // in the header for why. Tags every form-associable control inside the
  // container (Seal's radios + its own hidden state input) with
  // form="<real form id>" so they stay correctly submitted once relocate()
  // later moves the container elsewhere in the document.
  function tagFormAssociation(container) {
    var formEl = container.closest('form');
    var formId = formEl ? formEl.getAttribute('id') : null;
    if (!formId) return; // unexpected page structure -- skip rather than guess

    var controls = container.querySelectorAll('input, select, textarea, button');
    for (var i = 0; i < controls.length; i++) {
      controls[i].setAttribute('form', formId);
    }
  }

  // Collects each option's radio + its Seal-populated subs_interval field
  // (absent on the one-time option -- expected). Shared by the sync,
  // click, and price wiring below so they all read the same real nodes.
  function collectOptionPairs(container) {
    var options = Array.prototype.slice.call(container.querySelectorAll(OPTION_SELECTOR));
    var pairs = [];
    options.forEach(function (opt) {
      var radio = opt.querySelector('input[type="radio"]');
      if (!radio) return;
      var intervalEl = opt.querySelector(INTERVAL_SELECTOR);
      pairs.push({ option: opt, radio: radio, intervalEl: intervalEl });
    });
    return pairs;
  }

  // Restores the hand-off Seal's own (now-broken-by-relocation) event
  // delegation used to do: keeping container's own selling_plan hidden
  // input in sync with whichever option is checked. Reads the value from
  // each secondary option's own, Seal-populated subs_interval field --
  // Seal's own real data, just relayed to the field name Shopify's cart
  // actually reads. See SELLING-PLAN SYNC FIX in the header for the full
  // evidence trail. No-op if the expected fields aren't present.
  function wireSellingPlanSync(container) {
    var formEl = container.closest('form');
    var formId = formEl ? formEl.getAttribute('id') : null;

    var pairs = collectOptionPairs(container);
    if (!pairs.length) return;

    // Every selling_plan input this form will actually submit: the
    // container's own, plus any Seal renders/leaves as a real
    // descendant of the form, plus any tagged onto it via form= --
    // see DUPLICATE selling_plan INPUT FIX in the header for why
    // syncing only the container's copy is not enough.
    function allSellingPlanInputs() {
      var found = [];
      var candidates = document.querySelectorAll(SELLING_PLAN_INPUT_SELECTOR);
      for (var i = 0; i < candidates.length; i++) {
        var inp = candidates[i];
        if (container.contains(inp)) { found.push(inp); continue; }
        if (!formId) continue;
        var ancestorForm = inp.closest('form');
        if ((ancestorForm && ancestorForm.getAttribute('id') === formId) ||
            inp.getAttribute('form') === formId) {
          found.push(inp);
        }
      }
      return found;
    }

    function applySync() {
      var value = '';
      for (var i = 0; i < pairs.length; i++) {
        if (pairs[i].radio.checked) {
          value = pairs[i].intervalEl ? pairs[i].intervalEl.value : '';
          break;
        }
      }
      var inputs = allSellingPlanInputs();
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].value !== value) inputs[j].value = value;
      }
    }

    pairs.forEach(function (pair) {
      pair.radio.addEventListener('change', applySync);
    });

    // Seal re-renders bits of its markup after cart/variant events
    // (fresh random radio-group names, fresh hidden inputs), and Dawn
    // REPLACES the whole <form> node on variant changes -- confirmed
    // live: a form-scoped observer dies with the old node and a fresh,
    // empty selling_plan input arrives inside the new form. So the
    // observer lives on document.body (the same stable-ancestor rule
    // mr-tier-picker-prices.js already follows for Dawn's morphs), and
    // allSellingPlanInputs() re-queries by the STABLE form id string on
    // every pass rather than holding any node reference. Only ever
    // writes values that differ, so it settles in one pass and cannot
    // loop.
    new MutationObserver(applySync).observe(document.body, { childList: true, subtree: true });

    applySync(); // reflect whichever option is already checked at wire time
  }

  // Restores card selection on click -- see CARD-CLICK ACTIVATION FIX in
  // the header. Does exactly what a properly-associated label would have
  // done natively (check the radio, fire a bubbling 'change'), nothing
  // more. A no-op whenever the radio is already checked by the time the
  // click reaches the card -- i.e. on layouts where native/Seal handling
  // already worked -- so it is additive only where the chain was broken.
  function wireCardClicks(container) {
    var pairs = collectOptionPairs(container);
    pairs.forEach(function (pair) {
      pair.option.addEventListener('click', function (event) {
        if (event.target === pair.radio) return; // the radio's own native click handles itself
        if (pair.radio.checked) return;
        pair.radio.checked = true;
        pair.radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  // Keeps the main price display in step with the selected purchase
  // method -- see SUBSCRIPTION PRICE SYNC in the header. Prices come
  // exclusively from Shopify's own /products/<handle>.js
  // selling_plan_allocations (what the cart will actually charge); this
  // never computes a discount itself and silently does nothing if any
  // expected piece is missing.
  function wirePriceSync(container) {
    var initialForm = container.closest('form');
    var formId = initialForm ? initialForm.getAttribute('id') : null;
    if (!formId || formId.indexOf('product-form-') !== 0) return;
    var sectionId = formId.slice('product-form-'.length);
    if (!document.getElementById('price-' + sectionId)) return;

    var pairs = collectOptionPairs(container);
    if (!pairs.length) return;

    var productData = null;

    // Dawn replaces the <form> (and can replace the price wrapper) on
    // variant changes, so nodes are re-resolved by their STABLE ids on
    // every pass -- never held across renders.
    function currentVariant() {
      if (!productData) return null;
      var formEl = document.getElementById(formId);
      if (!formEl) return null;
      var idInput = formEl.querySelector('input[name="id"]');
      if (!idInput) return null;
      var vid = String(idInput.value);
      for (var i = 0; i < productData.variants.length; i++) {
        if (String(productData.variants[i].id) === vid) return productData.variants[i];
      }
      return null;
    }

    function selectedPlanId() {
      for (var i = 0; i < pairs.length; i++) {
        if (pairs[i].radio.checked) {
          return pairs[i].intervalEl ? String(pairs[i].intervalEl.value) : null;
        }
      }
      return null;
    }

    function targetCents(variant, planId) {
      if (!planId) return variant.price;
      var allocs = variant.selling_plan_allocations || [];
      for (var i = 0; i < allocs.length; i++) {
        if (String(allocs[i].selling_plan_id) === planId) return allocs[i].price;
      }
      return null; // plan not allocated to this variant -- leave display alone rather than guess
    }

    // Swaps only the numeric part of the element's own current text, so
    // whatever currency symbol/suffix the server rendered is preserved.
    function renderInto(el, cents) {
      var text = el.textContent;
      var match = /[\d][\d.,]*/.exec(text);
      if (!match) return;
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var next = text.replace(match[0], amount);
      if (next !== text) el.textContent = next;
    }

    function applyPrice() {
      var variant = currentVariant();
      if (!variant) return;
      var cents = targetCents(variant, selectedPlanId());
      if (cents == null) return;
      var priceWrap = document.getElementById('price-' + sectionId);
      if (!priceWrap) return;
      var targets = priceWrap.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale');
      for (var i = 0; i < targets.length; i++) {
        renderInto(targets[i], cents);
      }
    }

    fetch(window.location.pathname + '.js')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (!data || !data.variants) return;
        productData = data;

        pairs.forEach(function (pair) {
          pair.radio.addEventListener('change', applyPrice);
        });

        // Dawn morphs/replaces the price block on every variant change,
        // reverting the text to the one-time figure -- re-apply after
        // each morph. Observed from document.body because Dawn can
        // replace the wrapper node itself (same stable-ancestor rule as
        // the selling-plan observer above). Never writes when the text
        // already matches, so our own write settles the observer in one
        // extra, no-op pass.
        new MutationObserver(applyPrice).observe(document.body, { childList: true, subtree: true, characterData: true });

        applyPrice(); // reflect whichever option is already checked now
      })
      .catch(function () { /* fetch failed -- display stays server-rendered */ });
  }

  function restructure(container) {
    if (alreadyProcessed(container)) return true; // already built -- still a "success" for relocation purposes

    var options = Array.prototype.slice.call(container.querySelectorAll(OPTION_SELECTOR));
    if (options.length < 2) return false; // only one purchase option exists -- nothing to lay out as a grid, nothing to relocate

    var oneTimeOption = null;
    var secondaryOptions = [];
    options.forEach(function (opt) {
      var radio = opt.querySelector('input[type="radio"]');
      if (radio && radio.value === ONE_TIME_VALUE) {
        oneTimeOption = opt;
      } else {
        secondaryOptions.push(opt);
      }
    });

    // Unexpected data shape (no one_time option found, or nothing left to
    // show) -- do nothing rather than guess. Leaves Seal's own markup
    // exactly as rendered, and skips relocation too.
    if (!oneTimeOption || secondaryOptions.length === 0) return false;

    // Fix form association BEFORE any relocation happens --
    // container.closest('form') only finds the right answer while the
    // container is still genuinely nested inside the real <form>.
    tagFormAssociation(container);

    // Restore correct selling-plan submission (see SELLING-PLAN SYNC FIX
    // in the header). Order relative to relocation doesn't matter here --
    // addEventListener keeps working on a moved node -- but it's kept
    // next to tagFormAssociation() since both exist to fix the same
    // relocation-caused submission gap.
    wireSellingPlanSync(container);

    // Restore card-body selection (see CARD-CLICK ACTIVATION FIX) and
    // subscription price display (see SUBSCRIPTION PRICE SYNC). Both
    // feed off the same 'change' events wireSellingPlanSync() uses, so
    // the three stay in lock-step however the radio gets selected.
    // wirePriceSync() also needs the real form ancestor, so like
    // tagFormAssociation() it must run BEFORE relocate().
    wireCardClicks(container);
    wirePriceSync(container);

    // Relabel secondary rows using Seal's own live text as the source of
    // truth (see extractActWord()'s header comment); track the first
    // successfully-parsed act-word to reuse in the new heading.
    var actWord = null;
    secondaryOptions.forEach(function (opt) {
      var labelEl = opt.querySelector(LABEL_SELECTOR);
      if (!labelEl) return;
      var parsed = extractActWord(labelEl.textContent);
      if (parsed) {
        labelEl.textContent = (parsed.freq === 'weekly' ? 'Weekly ' : 'Monthly ') + parsed.actWord;
        if (!actWord) actWord = parsed.actWord;
      }
    });

    var built = buildCardsWrap(actWord);

    oneTimeOption.classList.add(CARD_CLASS);
    built.grid.appendChild(oneTimeOption); // moves the real, unmodified node -- listeners and checked state travel with it
    secondaryOptions.forEach(function (opt) {
      opt.classList.add(CARD_CLASS);
      built.grid.appendChild(opt); // same -- real node, not a clone
    });

    container.appendChild(built.wrap);
    return true;
  }

  // Removes the "Purchase options" label Seal renders as a sibling of the
  // container, left behind (empty, unlabelled) once the container itself
  // has moved away. Only ever removes that one specific label element --
  // Seal's separate "Subscription details" panel is a different element
  // one level up and is never touched.
  function removeStrandedHeading(originalParent) {
    if (!originalParent) return;
    var heading = originalParent.querySelector(PAGE_HEADING_SELECTOR);
    if (heading) heading.remove();
  }

  function relocate(container) {
    var shell = document.querySelector(SHELL_SELECTOR);
    if (!shell || shell.contains(container)) return; // no shell on this page/template, or already moved
    var originalParent = container.parentElement;
    shell.appendChild(container); // moves the real node -- Seal's own listeners/state travel with it, same technique as mr-selleasy-reposition.js
    removeStrandedHeading(originalParent);
  }

  function init(root) {
    root = root || document;
    var existing = root.querySelector(CONTAINER_SELECTOR);
    if (existing) {
      if (restructure(existing)) relocate(existing);
      return;
    }

    var observer = new MutationObserver(function () {
      var container = document.querySelector(CONTAINER_SELECTOR);
      if (container && restructure(container)) {
        relocate(container);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, GIVE_UP_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.MRSubscriptionPresentation = { init: init };
})();